import axios from 'axios';

export function createPageViewRecord(
  object_id: number,
  object_type: string = 'Auction',
  page_name: string = 'buyer_auction',
) {
  axios.post('/api/page_view/create_view_record', {
    object_id,
    object_type,
    page_name,
    start_time: new Date().toString(),
  });
}

export function createHamptonLotViewRecord(auctionId: number, lotId: number) {
  axios.post('/api/page_view/create_view_record', {
    object_id: auctionId,
    lot_number: lotId,
    object_type: 'Hampton',
    page_name: 'buyer_hampton',
    start_time: new Date().toString(),
  });
}

export function getAttachmentHandler(sessionKey: string, auctionId: number) {
  return {
    get: function (target: any, aucId: number) {
      if (aucId === auctionId) {
        return target[aucId];
      }
      // @ts-ignore
      return Reflect.get(...arguments);
    },
    set: function (target: any, aucId: number, value: any) {
      if (+aucId === auctionId) {
        target[aucId] = value;
        sessionStorage.setItem(sessionKey, JSON.stringify(target));
      }

      // @ts-ignore
      return Reflect.set(...arguments);
    },
    has: function (target: any, aucId: number) {
      return target.hasOwnProperty(aucId);
    },
  } as object;
}

export function getSortedCertificates(
  documents: AuctionsTypes.AuctionDocumentsType,
): Array<AuctionsTypes.AuctionDocumentType> {
  const giaCertificates: Array<AuctionsTypes.AuctionDocumentType> = [],
    restCertificates: Array<AuctionsTypes.AuctionDocumentType> = [];

  const sortedDocuments = Object.values(documents).reduce(
    (
      res: Array<AuctionsTypes.AuctionDocumentType>,
      document: AuctionsTypes.AuctionDocumentType,
    ) => {
      if (document.type) {
        if (document.type.toLowerCase().search('gia') > -1) {
          giaCertificates.push(document);
        } else {
          restCertificates.push(document);
        }
      }

      res = [...giaCertificates, ...restCertificates];
      return res;
    },
    [],
  );

  return sortedDocuments;
}

export function getFilterTextByValues(fieldProperties: any): string {
  if (fieldProperties.type === 'toggle' || fieldProperties.type === 'checkbox') {
    return fieldProperties.value ? 'true' : 'false';
  }

  if (fieldProperties.type === 'range') {
    if (!fieldProperties.data) {
      return fieldProperties.value.join('|').trim();
    }

    return fieldProperties.value
      .map((item: number) => fieldProperties.data[item].label)
      .join('|')
      .trim();
  }

  return fieldProperties.value
    .map(
      (item: number) =>
        fieldProperties.options.find((option: AuctionsTypes.OptionType) => option.value === item)
          .text,
    )
    .join('|')
    .trim();
}

export function getQuickFiltersInitialState<Type extends object>(
  filters: Type,
): {
  [key in keyof Type]: AuctionsTypes.QuickFiltersType[];
} {
  const keys = Object.keys(filters) as Array<keyof Type>;

  return keys.reduce((allFilters, type) => {
    const currentFilters = filters[type] as unknown as AuctionsTypes.FilterFields[];

    return {
      ...allFilters,
      [type]: currentFilters.map((filter) => ({ ...filter, initialValue: false, value: false })),
    };
  }, {}) as { [key in keyof Type]: AuctionsTypes.QuickFiltersType[] };
}

export function getPersonalizedFiltersInitialState<Type extends object>(
  filters: Type,
): {
  [key in keyof Type]: AuctionsTypes.PersonalizedFiltersType[];
} {
  const keys = Object.keys(filters) as Array<keyof Type>;

  return keys.reduce((allFilters, type) => {
    const currentFilters = filters[type] as unknown as AuctionsTypes.FilterFields[];

    return {
      ...allFilters,
      [type]: currentFilters.map((filter) => ({ ...filter, initialValue: false, value: false })),
    };
  }, {}) as { [key in keyof Type]: AuctionsTypes.PersonalizedFiltersType[] };
}
